import {
  baseLocale,
  deLocalizeHref,
  localizeHref,
  locales,
} from "~/paraglide/runtime";

const ROOT_RELATIVE_INTERNAL_HREF = /^\/(?!\/)/;
const ROUTER_BYPASS_PATH = /^\/(?:api(?:\/|$)|_server(?:\/|$))/;

/**
 * Localize an intentional same-origin full-document destination.
 *
 * Normal application navigation belongs in TanStack `Link`/`navigate`; this is
 * reserved for handoffs such as Better Auth OAuth callbacks that must leave the
 * current document. External, protocol, hash-only, and router-bypass URLs are
 * returned unchanged.
 */
export function localizeInternalHref(href: string): string {
  if (!ROOT_RELATIVE_INTERNAL_HREF.test(href) || ROUTER_BYPASS_PATH.test(href)) {
    return href;
  }

  const canonicalHref = deLocalizeHref(href);
  const localizedHref = localizeHref(canonicalHref);

  // Match the router's canonical localized-root form (`/de`, not `/de/`).
  const localizedRoot = new RegExp(
    `^/(${locales.filter((locale) => locale !== baseLocale).join("|")})/([?#].*)?$`,
  );
  return localizedHref.replace(localizedRoot, "/$1$2");
}
